<div class="right-panel h-100 text-grey">
  <div class="d-flex flex-column h-100">
        <div class="actionBar">
            <div class="flex-grow-1 h-100">
                <input 
                  class="search w-100"
                  type="text" 
                  placeholder="Search images..." 
                  [(ngModel)]="searchTerm"
                  (input)="filterImages()">
            </div>
            <button (click)="loadImages()"
                    type="button" 
                    class="actionBtn"
                    triggers="hover"
                    ngbTooltip="Refresh Images">
                <span class="bi bi-arrow-clockwise"></span>
            </button>
            <button (click)="createImage()" type="button" class="actionBtn" triggers="hover" ngbTooltip="Add Image">
                <span class="bi bi-device-hdd"></span>
                <span class="bi bi-plus-circle-fill overlay-icon-plus"></span>
            </button>            
        </div>
        <div class="right-side w-100">
            <div class="w-100">
                <div class="listTable">
                    <div class="jobs flex-grow-1">
                        <table class="table table-hover table-condensed " cellspacing="0" dynamicPagination [rowHeight]="32" [offsetHeight]="200" [paginationInstance]="config">
                            <thead>
                                <tr class="jobHeadRow" style="color: white; background-color: var(--s-primary-color);">
                                    <th resizable scope="col">
                                        <a style="text-decoration: none; cursor: default">#</a>
                                    </th>
                                    <th resizable scope="col">
                                        <a style="text-decoration: none; cursor: default">Image Name
                                            <span
                                                style="margin-left: 2px;"
                                                (click)="sortByImageName(true)"
                                                title="Sort Ascending/Descending"
                                                class="bi bi-arrow-down-up"
                                            ></span>
                                        </a>
                                    </th>
                                    <th resizable scope="col">
                                        <a style="text-decoration: none; cursor: default">Tag</a>
                                    </th>
                                    <th resizable scope="col">
                                        <a style="text-decoration: none; cursor: default">Image ID</a>
                                    </th>
                                    <th resizable scope="col">
                                        <a style="text-decoration: none; cursor: default">Size</a>
                                    </th>
                                    <th resizable scope="col">
                                        <a style="text-decoration: none; cursor: default">Created</a>
                                    </th>
                                    <th resizable scope="col">
                                        <a style="text-decoration: none; cursor: default">Created (ago)</a>
                                    </th>
                                    <th resizable scope="col">
                                        <a style="text-decoration: none; cursor: default">Tagged Registry</a>
                                    </th>
                                    <th resizable scope="col">
                                        <a style="text-decoration: none; cursor: default">Actions</a>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="scrollable-tbody">
                                <tr class="jobRow"
                                    *ngFor="let image of filteredImagesDTO | paginate: { itemsPerPage: config.itemsPerPage, currentPage: config.currentPage }; let i = index">
                                            <td style="cursor: pointer" scope="row">{{ i + 1 }}</td>
                                            <!-- <td style="cursor: pointer;" scope="row">{{ image.repository.includes('/') ? image.repository.split('/').pop() : image.repository }}</td> -->
                                            <td style="cursor: pointer;" scope="row">{{ image.imageName }}</td>
                                            <td style="cursor: pointer;" scope="row">{{ image.tag }}</td>
                                            <td style="cursor: pointer;" scope="row">{{ image.id }}</td>
                                            <td style="cursor: pointer;" scope="row">{{ image.size }}</td>
                                            <td style="cursor: pointer;" scope="row">
                                                <span class="created-date">{{ formatDate(image.created) }}</span>
                                            </td>
                                            <td style="cursor: pointer;" scope="row">
                                                <span class="relative-time">{{ getRelativeTime(image.created) }}</span>
                                            </td>
                                            <!-- <td style="cursor: pointer;" scope="row">{{ image.repository.includes('/') ? image.repository.split('/')[0] : 'NA' }}</td> -->
                                            <td style="cursor: pointer;" scope="row">{{ image.registryName }}</td>
                                            <td>
                                                <!-- <button 
                                                        (click)="inspectImage(image)"
                                                        type="button" 
                                                        class="listBtn"
                                                        triggers="hover"
                                                        ngbTooltip="Image Details">
                                                    <span class="bi bi-binoculars"
                                                    style="color: var(--s-primary-color); font-size: large; margin-right: 2px;"></span>
                                                </button> -->
                                                <button (click)="untagImage(image)"
                                                        type="button" 
                                                        class="listBtn"
                                                        triggers="hover"
                                                        ngbTooltip="Untag Image">
                                                    <span class="bi bi-trash text-danger"
                                                    style="color: var(--s-primary-color); font-size: large; margin-right: 2px;"></span>
                                                </button>
                                            </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                
                <pagination-controls class="my-pagination" (pageChange)="config.currentPage = $event" (pageBoundsCorrection)="config.currentPage = $event">
                </pagination-controls>
                </div>
            </div>
        </div>
    </div>
    <ngx-spinner
        bdColor="rgba(0,0,0,0)"
        size="default"
        zIndex="1"
        color="var(--s-primary-color)"
        type="ball-spin"
        [fullScreen]="false"
        >
        <p class="pleaseWait text-grey">Please wait ...</p>
    </ngx-spinner>
</div>